import { ADD_STEP_SHEET_BELOW } from "@sagot/constants";
import { useSyncExternalStore } from "react";

const QUERY = `(max-width: ${String(ADD_STEP_SHEET_BELOW - 1)}px)`;

function subscribe(notify: () => void): () => void {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", notify);
  return () => { media.removeEventListener("change", notify); };
}

/** True on a phone-width screen, where the Add-step menu opens as a bottom sheet instead of a popover. */
export function useNarrowScreen(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia(QUERY).matches, () => false);
}
